import PropTypes from "prop-types";
import { getEffectiveDefaultInsightsLens } from "../../../../constants/default-insights-lens";
import ProgramInsightsShell from "../../programs/program-insights/components/ProgramInsightsShell";

/**
 * Shared Program Insights strip for calendar date-range views.
 */
function CalendarInsightsStack({
  insightsInput,
  storageId,
  scrollRef,
  fromMetric,
  activeUser,
  activeUserToRequest,
  organizationOwner,
  clientConfiguration,
}) {
  if (!insightsInput || !storageId) {
    return null;
  }

  return (
    <div className="Program-Editor Program-Editor--insights-host-only">
      <ProgramInsightsShell
        cycleId={storageId}
        builderScrollRef={scrollRef}
        builderWeeks={insightsInput.builderWeeks}
        programExercises={insightsInput.programExercises}
        weekHeaderLabels={insightsInput.weekHeaderLabels}
        fromMetric={fromMetric}
        showDataSourceControl
        coachPreferences={{
          ...activeUserToRequest,
          defaultInsightsLens: getEffectiveDefaultInsightsLens(
            activeUser,
            organizationOwner,
            clientConfiguration,
          ),
        }}
      />
    </div>
  );
}

CalendarInsightsStack.propTypes = {
  insightsInput: PropTypes.shape({
    builderWeeks: PropTypes.object,
    programExercises: PropTypes.array,
    weekHeaderLabels: PropTypes.object,
  }),
  storageId: PropTypes.string.isRequired,
  scrollRef: PropTypes.shape({ current: PropTypes.any }),
  fromMetric: PropTypes.func,
  activeUser: PropTypes.object.isRequired,
  activeUserToRequest: PropTypes.object,
  organizationOwner: PropTypes.object,
  clientConfiguration: PropTypes.object,
};

export default CalendarInsightsStack;
